export const services = [
  {
    id: 1,
    name: 'Tire Sales & Installation',
    description: 'Quality tires for all vehicle types with professional installation',
    icon: 'CircleDot',
    featured: true
  },
  {
    id: 2,
    name: 'Oil Change',
    description: 'Fast and efficient oil change service at your location',
    icon: 'Droplet',
    featured: true
  },
  {
    id: 3,
    name: 'Brake Repair',
    description: 'Complete brake system inspection and repair services',
    icon: 'Disc',
    featured: true
  },
  {
    id: 4,
    name: 'Battery Service',
    description: 'Battery testing, replacement, and jump-start services',
    icon: 'Zap',
    featured: true
  },
  {
    id: 5,
    name: 'Roadside Assistance',
    description: '24/7 emergency roadside assistance when you need it most',
    icon: 'AlertCircle',
    featured: false
  },
  {
    id: 6,
    name: 'General Diagnostics',
    description: 'Professional vehicle diagnostics to identify any issues',
    icon: 'Search',
    featured: false
  }
];

export const tireCategories = [
  {
    id: 1,
    category: 'Passenger Car Tires',
    sizes: [
      { size: '185/65R15', price: 89.99, stock: 'In Stock' },
      { size: '195/65R15', price: 94.99, stock: 'In Stock' },
      { size: '205/55R16', price: 109.99, stock: 'In Stock' },
      { size: '215/60R16', price: 119.99, stock: 'In Stock' },
      { size: '225/45R17', price: 139.99, stock: 'In Stock' },
      { size: '235/45R18', price: 159.99, stock: 'Low Stock' }
    ]
  },
  {
    id: 2,
    category: 'SUV & Light Truck Tires',
    sizes: [
      { size: '225/65R17', price: 149.99, stock: 'In Stock' },
      { size: '235/65R17', price: 159.99, stock: 'In Stock' },
      { size: '245/70R17', price: 179.99, stock: 'In Stock' },
      { size: '265/70R17', price: 199.99, stock: 'In Stock' },
      { size: '275/65R18', price: 219.99, stock: 'In Stock' }
    ]
  },
  {
    id: 3,
    category: 'Heavy Duty Truck Tires',
    sizes: [
      { size: 'LT245/75R16', price: 189.99, stock: 'In Stock' },
      { size: 'LT265/75R16', price: 209.99, stock: 'In Stock' },
      { size: 'LT285/75R16', price: 229.99, stock: 'In Stock' },
      { size: 'LT315/75R16', price: 279.99, stock: 'In Stock' }
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Carlos Martinez',
    rating: 5,
    text: 'Excellent 24/7 service! Had a flat tire at 2 AM on I-95 and they were there in 20 minutes. Professional and fast!',
    service: 'Roadside Assistance',
    location: 'Miami, FL'
  },
  {
    id: 2,
    name: 'Jennifer Williams',
    rating: 5,
    text: 'Best mobile tire service in South Florida! They came to my office in Fort Lauderdale and installed 4 new tires. Great prices and very convenient.',
    service: 'Tire Installation',
    location: 'Fort Lauderdale, FL'
  },
  {
    id: 3,
    name: 'Robert Davis',
    rating: 5,
    text: 'Saved me on a road trip! Battery died in West Palm Beach and Vargas was there within 30 minutes. True lifesavers with 24/7 service.',
    service: 'Battery Service',
    location: 'West Palm Beach, FL'
  },
  {
    id: 4,
    name: 'Maria Gonzalez',
    rating: 5,
    text: 'Outstanding service! Called them at midnight for a tire blowout in Jacksonville. They arrived quickly and got me back on the road. Highly recommend!',
    service: 'Roadside Assistance',
    location: 'Jacksonville, FL'
  },
  {
    id: 5,
    name: 'David Thompson',
    rating: 5,
    text: 'Great experience with their mobile brake service in Naples. They came to my house, diagnosed the issue, and fixed it same day. Professional team!',
    service: 'Brake Repair',
    location: 'Naples, FL'
  },
  {
    id: 6,
    name: 'Lisa Rodriguez',
    rating: 5,
    text: 'Fantastic service in Miami Beach! Needed an oil change and they came right to my location. Quick, clean, and affordable. Will use again!',
    service: 'Oil Change',
    location: 'Miami Beach, FL'
  }
];
